import React, { ReactComponentElement, useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import InputMask from 'react-input-mask';
import { FaCreditCard, FaMobileAlt, FaCheck } from 'react-icons/fa'; // replace these icons with the ones you want
import * as S from './styles'
import SelectBox from '../SelectBox';
import { store } from '../../store';
import { Creators as SubscriptionCreators } from '../../store/ducks/subscription'
import { useSubscriptions } from '../../services/subscriptions.service';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { Button } from '../Button';
import { useTranslation } from 'react-i18next';
import { toMoney } from '../../utils/currency';
import { formatDate } from '../../utils/timeZone';
import { add } from 'date-fns';
import { CheckBox } from '../CheckBox';

function PaymentContent(props: any) {

    const {
        onSubmit,
        isLoading,
        errors,
        register,
        watch,
        checkCupom,
        resetCupom,
        verifyCoupon,
        resetVerifyCoupon,
        submitOnBlur,
        setValue,
        resetField,
        clearErrors,
        cupomCheckResponse,
        translationHome,
        translationSummary,
        subscriptionSelected,
        setSubscriptionSelected
    } = props

    // VARIABLES

    const {
        allExistingActiveSubscriptions,
        locale: { isNational }
    } = useTypedSelector(['allExistingActiveSubscriptions', 'locale'])

    const [availableInstallmentsLabelsCC, setAvailableInstallmentsLabelsCC] = useState<any[] | undefined>([]);
    const [isCupomValid, setIsCupomValid] = useState<boolean>(false);
    const [subTotal, setSubTotal] = useState<string>(isNational || !isNational ? 'R$ 00,00' : 'U$ 00.00')
    const [discountValue, setDiscountValue] = useState<string>(isNational || !isNational ? 'R$ 00,00' : 'U$ 00.00')
    const [totalValue, setTotalValue] = useState<string>(isNational || !isNational ? 'R$ 00,00' : 'U$ 00.00')
    const [paymentMethodLabel, setPaymentMethodLabel] = useState<string>('Cartão de crédito')
    const [renovationDuration, setRenovationDuration] = useState('')
    const [newRenovationDate, setNewRenovationDate] = useState<Date>(new Date())
    const [planName, setPlanName] = useState<string>('O Antagonista+')
    const [selectBox, setSelectBox] = useState<any>();

    const urlParams = new URLSearchParams(window.location.search)
    const planFromQuery = urlParams.get('plano')
    const periodFromQuery = urlParams.get('tipo')
    const cupomFromQuery = urlParams.get('cupom')

    const fields = watch()

    // USE EFFECTS 

    useEffect(() => {
        const exec = async () => {
            if (cupomFromQuery && cupomFromQuery !== '' && cupomFromQuery !== undefined) {
                sessionStorage.setItem('cupom', cupomFromQuery)
                setValue('voucher', cupomFromQuery)
                checkCupom && await checkCupom(cupomFromQuery, 'creditCard', '1')
            } else {
                let cupom = sessionStorage.getItem('cupom')
                if (cupom) {
                    checkCupom && await checkCupom(cupom, 'creditCard', '1')
                } else {
                    sessionStorage.removeItem('cupom')
                }
            }
        }
        exec();
    }, [])

    useEffect(() => {
        if (!fields?.installments) setValue("installments", "1")
        setPaymentMethodLabel(fields.payment !== 'pix' ? 'Cartão de crédito' : 'Pix')
        setIsCupomValid(cupomCheckResponse?.data?.valid)
        cupomCheckResponse?.data?.valid && clearErrors('voucher')
        calculateTotals()

    }, [allExistingActiveSubscriptions, fields.installments, fields.payment, cupomCheckResponse])

    useEffect(() => {
        const exec = async () => {
            const cupom = sessionStorage.getItem('cupom')
            cupom === null && resetField('voucher')
            cupom !== null && cupom !== undefined && fields.voucher !== cupom && fields.voucher !== undefined && setValue('voucher', cupom)
            checkCupom && await checkCupom(cupom, fields.payment, fields.installments)
        }
        exec();
    }, [fields.payment, fields.installments, subscriptionSelected])

    useEffect(() => {

        const str = totalValue.trim().replace("R$", "").replace(",", ".")
        const totalValueParsed = parseFloat(str);

        if (totalValueParsed && totalValueParsed > 0) {

            setInstallmentsCC()
        }

    }, [totalValue])

    useEffect(() => {

        const component = <SelectBox
            options={availableInstallmentsLabelsCC ?? []}
            name="selectOption"
            placeholder="Parcelas"
            extraText={availableInstallmentsLabelsCC?.find(x => x.value === fields.installments)?.total}
            onChange={(e) => {
                setValue("installments", e.target.value)
            }}
        />

        setSelectBox(component)

    }, [availableInstallmentsLabelsCC])

    useEffect(() => {
        setValue("captchaStatus", 0);
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
        script.onload = () => {
            setValue("gRecaptchaResponse", '');
            onloadCallback();
        };
    }, []);

    // FUNCTIONS

    function sleep (time: any) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }

    function onloadCallback() {
        sleep(500).then(() => {
            window.grecaptcha.render('recaptcha-container', {
                'sitekey' : process.env.REACT_APP_RECAPTCHA_SITE_KEY,
                'callback' : handleRecaptchaChange
            });
            setValue("captchaStatus", 1);
        });
    }

    function setInstallmentsCC() {
        if (!Object.values(allExistingActiveSubscriptions).length) return

        let mrcProduct = planFromQuery === 'crusoe' ? 'crs' : planFromQuery === 'antagonista' ? 'oam' : 'a+ccbo'

        const availableInstallmentsSubs = Object.values(allExistingActiveSubscriptions)?.filter(plan => {
            return plan.vindi_plan_interval_name.toLowerCase() === periodFromQuery?.toLowerCase() &&
                mrcProduct.includes(plan.mrc_product)
        })

        const installments: any[] = availableInstallmentsSubs?.map(x => {

            const subTotalValueString = x.price_BRL.trim().replace("R$", "").replace(",", ".")
            const subTotalValueParsed = parseFloat(subTotalValueString)

            const cupomValidForInstallments = cupomCheckResponse?.data?.parcelas?.split(',')?.map((x: string) => (Number)(x))
            const isCupomValidForThisInstallment = cupomCheckResponse && cupomCheckResponse?.data?.valid && cupomValidForInstallments.includes(x.vindi_plan_installments)

            let cupomDiscountValue = 0

            if (isCupomValidForThisInstallment) {
                let voucherDiscountValue = cupomCheckResponse?.data?.valor ?? 0

                if (cupomCheckResponse?.data?.tipo_cupom === 'moeda') {
                    cupomDiscountValue = +cupomCheckResponse?.data?.valor
                }

                if (cupomCheckResponse?.data?.tipo_cupom === 'perc') {
                    cupomDiscountValue = (+voucherDiscountValue / 100) * subTotalValueParsed
                }
            }

            const totalPrice = subTotalValueParsed - cupomDiscountValue
            const totalPriceDividedByInstallments = x.vindi_plan_installments > 1 ? toMoney(totalPrice / x.vindi_plan_installments) : toMoney(totalPrice)

            const result = {
                label: `${x.vindi_plan_installments}x de ${totalPriceDividedByInstallments} `,
                value: x.vindi_plan_installments.toString(),
                total: toMoney(totalPrice)
            };

            return result
        })

        setAvailableInstallmentsLabelsCC(installments)
    }

    function calculateTotals() {
        if (!Object.values(allExistingActiveSubscriptions).length) return

        let mrcProduct = planFromQuery === 'crusoe' ? 'crs' : planFromQuery === 'antagonista' ? 'oam' : 'a+ccbo'

        const subscriptionSelected = Object.values(allExistingActiveSubscriptions)
            .find(
                x => x.vindi_plan_interval_name.toLowerCase() === periodFromQuery?.toLowerCase() &&
                    mrcProduct.includes(x.mrc_product) &&
                    x.vindi_plan_installments == (fields.payment === 'pix' ? '1' : fields.installments)
            )

        if (!subscriptionSelected?.price_BRL && !subscriptionSelected?.price_USD) return

        setSubscriptionSelected(subscriptionSelected)

        const isCupomValid = cupomCheckResponse?.data?.valid

        const subTotal = isNational ? subscriptionSelected?.price_BRL : subscriptionSelected?.price_USD

        const subTotalSymbolAndPrice = subTotal.split(' ')
        const subTotalParsedNumber = +subTotalSymbolAndPrice[1]?.replace(',', '.')
        let discountedValue = 0

        if (isCupomValid) {
            let voucherDiscountValue = cupomCheckResponse?.data?.valor ?? 0
            let voucherDiscountPercentage = (+voucherDiscountValue / 100) * subTotalParsedNumber

            if (cupomCheckResponse?.data?.tipo_cupom === 'moeda') {
                discountedValue = +cupomCheckResponse?.data?.valor
            }

            if (cupomCheckResponse?.data?.tipo_cupom === 'perc') {
                discountedValue = subTotalParsedNumber - (subTotalParsedNumber - voucherDiscountPercentage) 
            }
        }

        let total = toMoney(subTotalParsedNumber - discountedValue)

        setSubTotal(subTotal)
        setDiscountValue(toMoney(discountedValue))
        setTotalValue(total)

        const renovationDuration = subscriptionSelected?.durationDays === 30 ? translationSummary('MONTHLY') :
            subscriptionSelected?.durationDays === 180 ? translationSummary('SEMESTRAL') : translationSummary('ANNUALLY')

        const newRenovationDate = add(
            new Date(),
            subscriptionSelected?.durationDays === 30 ? {
                months: 1
            } : subscriptionSelected?.durationDays === 180 ? {
                months: 6
            } :
                {
                    years: 1
                }
        )

        setRenovationDuration(renovationDuration)
        setNewRenovationDate(newRenovationDate)

        subscriptionSelected?.vindi_plan_description &&
            subscriptionSelected?.vindi_plan_description !== '' &&
            setPlanName(subscriptionSelected?.vindi_plan_description)
    }

    const handleCreditCardClick = () => {
        setValue('payment', fields.payment === 'creditCard' ? 'creditCard' : 'creditCard')
    };

    const handleRecaptchaChange = useCallback((value: any) => {
        setValue("gRecaptchaResponse", value);
    }, []);

    const handlePixClick = () => {
        setValue('payment', fields.payment === 'pix' ? 'pix' : 'pix')
    };

    const toggleForm = (paymentType: string) => {
        if (paymentType === 'creditCard') {
            handleCreditCardClick()
        } else {
            handlePixClick()
        }
    };

    const handleVoucherBlurCustom = async (payment: string) => {
        if (fields.voucher !== undefined) {
            sessionStorage.setItem('cupom', fields.voucher)
            checkCupom && await checkCupom(fields.voucher, payment, "1")
        } else {
            setIsCupomValid(false)
            resetCupom()
            resetField('voucher')
            sessionStorage.removeItem('cupom')
        }
    }

    const handleVoucherReset = async (payment: string) => {
        setIsCupomValid(false)
        resetCupom()
        resetField('voucher')
        sessionStorage.removeItem('cupom')
    }

    return (
        <>
            <S.PaymentTextContainer>
                <S.TextBlue>{translationHome('HOW_TO_PAY_GREAT')}</S.TextBlue>
                <S.TextBlack>{translationHome('HOW_TO_PAY_NOW_CHOOSE')}</S.TextBlack>
            </S.PaymentTextContainer>
            <S.TextBelow>{translationHome('HOW_TO_PAY')}</S.TextBelow>
            <S.ContainerPaymentForm>
                <S.FormWrapperCC>
                    <S.FormHeaderCC onClick={() => toggleForm('creditCard')}>
                        <S.IconContainer>
                            <FaCreditCard />
                        </S.IconContainer>
                        <S.FormTitle>Cartão de Crédito</S.FormTitle>
                    </S.FormHeaderCC>
                    <S.FormBodyCC isOpen={fields.payment === 'creditCard'}>
                        <S.InputWrapper>
                            <S.Input placeholder="Nome impresso no cartão"
                                {...register("cardName", {
                                    onBlur: () => { submitOnBlur && submitOnBlur(); }
                                })}
                            />
                            {errors?.cardName?.message ? <S.ErrorMessage>{errors?.cardName?.message}</S.ErrorMessage> : null}
                            <S.InputMasked maskChar={null} alwaysShowMask={false} mask="9999 9999 9999 9999" placeholder="0000 0000 0000 0000"
                                {...register("cardNumber", {
                                    onBlur: () => { submitOnBlur && submitOnBlur(); }
                                })}
                            />
                            {errors?.cardNumber?.message ? <S.ErrorMessage>{errors?.cardNumber?.message}</S.ErrorMessage> : null}
                            {/* <S.HalfInputWrapper>
                                <div> */}
                            <S.InputMasked maskChar={null} alwaysShowMask={false} mask="99/99" placeholder="MM/AA"
                                {...register("cardDate", {
                                    onBlur: () => { submitOnBlur && submitOnBlur(); }
                                })}
                            />
                            {/* <div style={{ marginTop: '10px' }}></div> */}
                            {errors?.cardDate?.message ? <S.ErrorMessage>{errors?.cardDate?.message}</S.ErrorMessage> : null}

                            {/* </div>
                                <div> */}
                            <S.InputMasked maskChar={null} alwaysShowMask={false} mask="9999" placeholder="CVV"
                                {...register("cardCVV", {
                                    onBlur: () => { submitOnBlur && submitOnBlur(); }
                                })}
                            />
                            {/* <div style={{ marginTop: '10px' }}></div> */}
                            {errors?.cardCVV?.message ? <S.ErrorMessage>{errors?.cardCVV?.message}</S.ErrorMessage> : null}
                            {/* </div>
                            </S.HalfInputWrapper> */}
                            {selectBox && selectBox}
                            {errors?.installments?.message ? <S.ErrorMessage>{errors?.installments?.message}</S.ErrorMessage> : null}
                        </S.InputWrapper>
                        <S.CouponSection>
                            <span>Código do cupom</span>
                            <S.InputWrapper>
                                {fields.payment === 'creditCard' ? <S.InputVoucher isCupomSet={isCupomValid}
                                    {...register("voucher", {
                                        onBlur: () => { submitOnBlur && submitOnBlur(); handleVoucherBlurCustom('creditCard'); }
                                    })} /> : <S.InputVoucher />}
                                {isCupomValid && <S.XButton onClick={() => handleVoucherReset('creditCard')} />}
                                {!isCupomValid && fields.voucher && <S.CheckButton onClick={() => handleVoucherBlurCustom('creditCard')} />}
                            </S.InputWrapper>
                            {isCupomValid && <S.SuccessMessage>{'Cupom Aplicado com Sucesso!'}</S.SuccessMessage>}
                            {errors?.voucher?.message ? <S.ErrorMessage>{errors?.voucher?.message}</S.ErrorMessage> : null}
                        </S.CouponSection>
                    </S.FormBodyCC>
                </S.FormWrapperCC>
                {/* <div style={{ width: '30px' }}></div> */}
                <S.FormWrapperPix>
                    <S.FormHeaderPix onClick={() => toggleForm('pix')}>
                        <S.IconContainer>
                            <FaMobileAlt />
                        </S.IconContainer>
                        <S.FormTitle>Pix</S.FormTitle>
                    </S.FormHeaderPix>
                    <S.FormBodyPix isOpen={fields.payment === 'pix'}>
                        <S.InputWrapper>
                            <S.Input isPix={true} placeholder="Valor" className='non-interactive-input' />
                            {
                                <S.ExtraText>{availableInstallmentsLabelsCC?.find(x => x.value === '1')?.total}</S.ExtraText>
                            }
                        </S.InputWrapper>

                        {/* <S.HalfInputWrapper>
                            <S.HalfInput className="invisible-input" />
                            <S.HalfInput className="invisible-input" />
                        </S.HalfInputWrapper> */}

                        <S.CouponSection>
                            <span>Código do cupom</span>
                            <S.InputWrapper>
                                {fields.payment === 'pix' ? <S.InputVoucher isCupomSet={isCupomValid}
                                    {...register("voucher", {
                                        onBlur: () => { submitOnBlur && submitOnBlur(); handleVoucherBlurCustom('pix'); }
                                    })} /> : <S.InputVoucher />}
                                {isCupomValid && <S.XButton onClick={() => handleVoucherReset('pix')} />}
                                {!isCupomValid && fields.voucher && <S.CheckButton onClick={() => handleVoucherBlurCustom('pix')} />}
                            </S.InputWrapper>
                            {isCupomValid && <S.SuccessMessage>{'Cupom Aplicado com Sucesso!'}</S.SuccessMessage>}
                            {errors?.voucher?.message ? <S.ErrorMessage>{errors?.voucher?.message}</S.ErrorMessage> : null}
                        </S.CouponSection>
                    </S.FormBodyPix>
                </S.FormWrapperPix>
            </S.ContainerPaymentForm>


            <S.ContentSummary>
                <S.SummarySlug>{translationHome('SUMMARY')}</S.SummarySlug>
                <S.ContainerSummary>

                    {fields.payment !== 'pix' && <S.Content>
                        <S.SectionLeft>
                            <S.LeftColumn>
                                <S.SecondaryText>{translationSummary('SELECTED_SUBSCRIPTION')}</S.SecondaryText>
                                <S.PrimaryText>{planName}</S.PrimaryText>

                                <div style={{ marginBottom: '1rem' }}></div>

                                <S.SecondaryText>
                                    {translationSummary('IN_CASH_PAYMENT')}{renovationDuration} {translationSummary('RENEW_IN')}{' '}{formatDate(newRenovationDate)}
                                </S.SecondaryText>

                                <div style={{ marginBottom: '1rem' }}></div>

                            </S.LeftColumn>

                            <S.LeftColumn>
                                <S.Tertiary>{translationSummary('PAYMENT')}</S.Tertiary>
                                <S.SecondaryText>{paymentMethodLabel} - {availableInstallmentsLabelsCC?.find(x => x.value === fields.installments)?.label}</S.SecondaryText>
                            </S.LeftColumn>
                        </S.SectionLeft>

                        <div style={{ marginBottom: '1rem' }}></div>

                        <S.SectionRight>
                            <S.RightColumn>
                                <S.Row>
                                    <S.SecondaryText>{translationSummary('SUBTOTAL')}</S.SecondaryText>
                                    <S.PrimaryText>{subTotal}</S.PrimaryText>
                                </S.Row>

                                <S.Row>
                                    <S.SecondaryText>{translationSummary('DISCOUNT')}</S.SecondaryText>
                                    <S.PrimaryText style={{ color: '#FFA500' }}>
                                        {discountValue}
                                    </S.PrimaryText>
                                </S.Row>

                                <S.Row>
                                    <S.TotalText>TOTAL&nbsp;</S.TotalText>
                                    <S.TotalValue>{totalValue}</S.TotalValue>
                                </S.Row>

                            </S.RightColumn>
                        </S.SectionRight>
                    </S.Content>}

                    {fields.payment === 'pix' && <S.Content>
                        <S.SectionLeft>
                            <S.LeftColumn>
                                <S.SecondaryText>{translationSummary('SELECTED_SUBSCRIPTION')}</S.SecondaryText>
                                <S.PrimaryText>{planName}</S.PrimaryText>

                                <div style={{ marginBottom: '1rem' }}></div>

                                <S.SecondaryText>
                                    {translationSummary('IN_CASH_PAYMENT')}{renovationDuration} {translationSummary('RENEW_IN')}{' '}{formatDate(newRenovationDate)}
                                </S.SecondaryText>

                                <div style={{ marginBottom: '1rem' }}></div>

                            </S.LeftColumn>

                            <S.LeftColumn>
                                <S.Tertiary>{translationSummary('PAYMENT')}</S.Tertiary>
                                <S.SecondaryText>{paymentMethodLabel}  - à vista</S.SecondaryText>
                            </S.LeftColumn>
                        </S.SectionLeft>

                        <div style={{ marginBottom: '1rem' }}></div>

                        <S.SectionRight>
                            <S.RightColumn>
                                <S.Row>
                                    <S.SecondaryText>{translationSummary('SUBTOTAL')}</S.SecondaryText>
                                    <S.PrimaryText>{subTotal}</S.PrimaryText>
                                </S.Row>

                                <S.Row>
                                    <S.SecondaryText>{translationSummary('DISCOUNT')}</S.SecondaryText>
                                    <S.PrimaryText style={{ color: '#FFA500' }}>
                                        {discountValue}
                                    </S.PrimaryText>
                                </S.Row>

                                <S.Row>
                                    <S.TotalText>TOTAL&nbsp;</S.TotalText>
                                    <S.TotalValue>{totalValue}</S.TotalValue>
                                </S.Row>

                            </S.RightColumn>
                        </S.SectionRight>
                    </S.Content>}

                    <div className="separator" style={{ margin: '2rem 0 2rem 0', backgroundColor: '#fff', height: '1px', width: '100%' }}></div>

                    <S.Checkboxs>
                        <S.ScreenCheckBox>
                            <CheckBox
                                label={'Li e concordo com os Termos de Uso e Política de Privacidade.'}
                                id={'termsChecked'}
                                {...register("termsChecked", {

                                    onBlur: () => { submitOnBlur && submitOnBlur(); }
                                })}
                            />
                            {errors?.termsChecked?.message ? <S.ErrorMessage>{errors?.termsChecked?.message}</S.ErrorMessage> : null}
                        </S.ScreenCheckBox>

                        <S.ScreenCheckBox>
                            <CheckBox
                                label={'Aceito receber notificações sobre minha assinatura.'}
                                id={'notificationsChecked'}
                                {...register("notificationsChecked", {

                                    onBlur: () => { submitOnBlur && submitOnBlur(); }
                                })}
                            />
                        </S.ScreenCheckBox>

                        <S.ScreenCheckBox>
                            <CheckBox
                                label={('Aceito a renovação automática de minha assinatura.')}
                                id={'renovationChecked'}
                                {...register("renovationChecked", {

                                    onBlur: () => { submitOnBlur && submitOnBlur(); }
                                })}
                            />
                        </S.ScreenCheckBox>

                        <S.TermsLinks>
                            <a href="https://oantagonista.com.br/termos-de-uso/" target="_blank" rel='noreferrer'>Termos de Uso</a> | <a href="https://oantagonista.com.br/politica-de-privacidade/" target="_blank">Política de Privacidade</a>
                        </S.TermsLinks>

                    </S.Checkboxs>

                    <div
                        id="recaptcha-container"
                        style={{ marginBottom: '2rem'}}
                    ></div>

                    <Button
                        type='submit'
                        label={'Finalizar Compra'}
                        onClick={onSubmit}
                        isLoading={isLoading}
                    />


                </S.ContainerSummary>
            </S.ContentSummary>
        </>

    );
}

export default PaymentContent
